module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(false) ? _c('div', [_c('section', {
    staticClass: "d-flex align-items-center pb-1",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('stacked-bar-graph', {
    attrs: {
      "styles": _vm.myStyles,
      "data": _vm.videoData
    }
  }), _vm._v(" "), _c('stacked-bar-graph', {
    attrs: {
      "styles": _vm.myStyles,
      "data": _vm.commentData
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.data), function(u) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(u.User))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.Videos))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.Duration))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u['Avg Duration']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u['Shared Videos']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.Comments))])])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("User")]), _vm._v(" "), _c('th', [_vm._v("Videos Uploaded")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-tippy-arrow": "true",
      "data-tippy": "Total duration of uploaded videos"
    }
  }, [_vm._v("Total Video Duration (h:mm:ss)")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-tippy-arrow": "true",
      "data-tippy": "Avg duration of uploaded videos"
    }
  }, [_vm._v("Avg Video Duration (h:mm:ss)")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-tippy-arrow": "true",
      "data-tippy": "Number of your videos that you have shared"
    }
  }, [_vm._v("Shared Videos")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-tippy-arrow": "true",
      "data-tippy": "Number of comments you added across any video"
    }
  }, [_vm._v("Comments")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-f94ca518"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataPane.vue
// module id = 1097
// module chunks = 0